/** Spec §14.3: every action/result shows its real state — never a fake green "protected". */
const KNOWN = new Set([
  "REQUESTED",
  "SENT",
  "APPLIED",
  "VERIFIED",
  "FAILED",
  "EXPIRED",
  "NOT_SUPPORTED",
]);

export function StateBadge({ state }: { state: string }) {
  const cls =
    KNOWN.has(state) ||
    [
      "ok",
      "warning",
      "danger",
      "allowed",
      "denied",
      "quarantined",
      "unrated",
    ].includes(state)
      ? state
      : "warning";
  return (
    <span className={`badge ${cls}`}>
      {(
        {
          allowed: "Allowed",
          denied: "Blocked",
          unrated: "Not reviewed",
          quarantined: "Quarantined",
        } as Record<string, string>
      )[state] ?? state}
    </span>
  );
}

export function CoverageNote({
  coverage,
}: {
  coverage: Record<string, unknown>;
}) {
  const minutes =
    typeof coverage.audio_minutes === "number" ? coverage.audio_minutes : null;
  if (minutes === null || minutes <= 0) {
    return (
      <p className="notice">
        NO RECORDING — this report has no audio to assess.
      </p>
    );
  }
  const oneSided = coverage.one_sided === true;
  return (
    <p className="notice">
      Audio reviewed: {Math.round(minutes)} min
      {oneSided ? " — ONE_SIDED_AUDIO (local mic only)" : ""}
    </p>
  );
}
